import React from 'react';
import styles from 'cms-components/RichText/RichText.module.scss';
import { extractInlineStyles } from '../utils';
import { RichTextNode } from '../types';

const RichTextBold = ({ children, value }: RichTextNode) => (
  <strong className={styles.richTextStrong} style={extractInlineStyles(value)}>
    {children}
  </strong>
);

export default RichTextBold;
